import './SearchBoxes.scss';

import React, { useState } from 'react';
import PropTypes from 'prop-types'

import Button from 'components/Button';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormColumn from 'components/FormColumn';
import Icon from 'components/Icon';
import SearchModal from "./SearchModal";
import Textbox from 'components/Textbox';

const SearchBoxes = ({isSearching, location, nameSearchTerm, searchEpiloggs, setLocation, setNameSearchTerm}) => {
    const [showSearchModal, setShowSearchModal] = useState(false);

    return (
        <Form>
            <FormRow
                className="search-boxes"
                columnCount={2}
            >
                <FormColumn>
                    <Textbox
                        label="search by name"
                        name="nameSearchTerm"
                        onChange={(event) => setNameSearchTerm(event.target.value)}
                        placeholder="search by name"
                        theme="border"
                        value={nameSearchTerm}
                    />
                </FormColumn>

                <FormColumn>
                    <Textbox
                        label="search by city or zipcode"
                        name="locationSearchTerm"
                        onFocus={(event) => {
                            if(!showSearchModal) {
                                setShowSearchModal(true);
                                event.target.blur();
                            }
                        }}
                        placeholder="city or zipcode"
                        theme="border"
                        value={location ? location.displayName : ''}
                    />

                    {location ? (
                        <Button
                            className="search-boxes__clear-location"
                            noStyles
                            onClick={() => setLocation(null)}
                            type="button"
                        >
                            <Icon type="x" />
                        </Button>
                    ) : null}
                </FormColumn>

                <Button
                    className="search-button"
                    disabled={isSearching}
                    noStyles
                    onClick={(event) => {
                        event.preventDefault();
                        searchEpiloggs();
                    }}
                    showActivityIndicator={isSearching}
                    type="submit"
                >
                    <Icon type="search" />
                </Button>

                <SearchModal
                    closeModal={() => setShowSearchModal(false)}
                    handleSelect={setLocation}
                    show={showSearchModal}
                />
            </FormRow>
        </Form>
    );
};

SearchBoxes.propTypes = {
    isSearching: PropTypes.bool.isRequired,
    location: PropTypes.object,
    nameSearchTerm: PropTypes.string.isRequired,
    searchEpiloggs: PropTypes.func.isRequired,
    setLocation: PropTypes.func.isRequired,
    setNameSearchTerm: PropTypes.func.isRequired
};

export default SearchBoxes;
